<template>
    <div class="page">
        <div class = "monitor-header">
            <div class = "time-header">
                <el-button icon="jc-icon-refresh-line" class="jc-button-icon" 
                @click="handleRefresh"></el-button>
                <div>
                    <el-radio-group ref="radios"
                        v-model="pickerShortcutButton"
                        @change="onDateRangeChange">
                        <el-radio-button v-for="item in shortcuts"
                            :key="item.label"
                            :label="item.label">{{item.name}}
                        </el-radio-button>
                    </el-radio-group>
                    <el-date-picker ref="picker"
                        v-model="pickerValue"                       
                        :placeholder="$t('detail.text.rangeForSearch')"
                        :range-separator="$t('detail.text.rangeSeparator')"
                        :editable="false"
                        :picker-options="pickerOptions"
                        @change="pickerChange"
                        type="daterange"
                        format="yyyy-MM-dd"
                        align="right"
                        unlink-panels>
                    </el-date-picker>
                </div>    
                <div class="monitor-alarm-rule">
                    <p>{{$t('listPage.speechCraft.monitorTo') }}<a :href="Config.MONITOR_RULE_URL+'overview'" target="_blank">
                    {{$t('listPage.speechCraft.alarmRules') }}</a></p>
                </div>
            </div>
        </div>
        <div class="monitor-chart">
            <div v-for="(item,index) in metrics">
                <single-monitor-chart
                    :key='item.guid'
                    :metric="item.include"
                    :serviceCode="serviceCode"
                    :title='item.title'
                    :initialTitle="item.initialTitle"
                    :resourceId="resourceId"
                    :regionId="regionId"
                    :timeInterval="pickerShortcutButton"
                    :startTime="startTime"
                    :endTime="endTime"
                    :selectChange="selectInstance"
                    :changeDisk="diskChangeList"
                    :changeMountpoint="mountpointChangeList"
                    :changeNic="nicChangeList"
                    :updateSign="updateChange"
                    :nicChange="nicChange"
                    :mountpointChange="mountpointChange"
                />
            </div>
            <div class="add-border">{{'none'}}</div>
        </div>
    </div>
</template>

<script>
import {guid} from "@/common/tool";
import SingleMonitorChart from "@/components/common/PerformanceMonitor/SingleMonitorChart.vue";

const ONE_HOUR = 3600 * 1000;
const _now = () => (new Date()).getTime();
export default {
    name: 'PerformanceMonitor',
    components: { SingleMonitorChart },
    props: {
        regionId: {
            type: String,
            default: ''
        },
        resourceId: {
            type: String,
            default: ''
        },

        metrics: {
            type: Array,
            default: []
        },

        serviceCode: {
            type: String,
            default: ''
        },
    },
    data() {
        return {  
            pickerValue:'',
            pickerShortcutButton: '1h',
            selectInstance: 1,
            dateRangeValue: '',
            diskChange: '',
            mountpointChange:'',
            nicChange:'',
            disk:'',
            diskChangeList:{},
            mountpointChangeList:{},
            nicChangeList:{},
            updateChange: 0,
            startTime:'',
            endTime:'',
            shortcuts: [
                { label: '1h', name: '1'+ this.$t('detail.text.timeRangeH') },
                { label: '6h', name: '6'+ this.$t('detail.text.timeRangeH') },
                { label: '12h', name: '12'+ this.$t('detail.text.timeRangeH') },
                { label: '1d', name: '1'+ this.$t('detail.text.timeRangeD') },
                { label: '3d', name: '3'+ this.$t('detail.text.timeRangeD') },
                { label: '7d', name: '7'+ this.$t('detail.text.timeRangeD') },
                { label: '14d', name: '14'+ this.$t('detail.text.timeRangeD') },
            ],           
            
            pickerOptions: {
                disabledDate (time) {
                    const t = time.getTime();
                    const now = _now();
                    const laterThenNow = t > now;
                    const earlierThenRange = t < now - ONE_HOUR * 24 * 30;
                    return earlierThenRange || laterThenNow;
                },
                onPick ({ maxDate, minDate }) {
                    const bothSelected = !!maxDate && !!minDate;
                    if (!bothSelected) return; // 解决首次不触发
                    setTimeout(() => {
                        this.pickerValue = [minDate, maxDate];
                        //console.log('position 1', this.pickerValue);
                    }, 200);
                }
            },

        };
    },
    computed: {
    },
    watch: {

    },
    created() {
    },
    methods: {
        handleRefresh() {
            this.updateChange ++;
        },
        onDateRangeChange() {
           if(this.pickerShortcutButton !== '') {
                this.pickerValue = ''
           } 
        },
        pickerChange() {
            if(this.pickerValue[1] !== null) {
                this.pickerShortcutButton = ''
                this.startTime = new Date(+this.pickerValue[0] + 8 * 3600 * 1000).toISOString().replace(/\.[\d]{3}Z/,'');
                this.endTime = new Date(+this.pickerValue[1] + 32 * 3600 * 1000 - 1 ).toISOString().replace(/\.[\d]{3}Z/,'');
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.monitor-header {
    background-color: #f3f7fb;
    border: 1px solid #d9e1e9;
}

.jc-button-icon {
    margin-right:10px;
}

.time-header {
    display: flex;
    align-items:center;
    margin: 15px;
}

.monitor-alarm-rule {
    margin-left: auto;
}

.select-instance {
    display:inline-block;
    margin-left: 40px;
    margin-bottom: 10px;
}

.select-disk {
    width: 200px;
    margin-right: 10px;
    display:inline-block;
}

.el-date-editor {
    margin-left: 10px;
}

.monitor-chart {
    background: white;
    border-bottom: 1px solid #d9e1e9;
    border-left: 1px solid #d9e1e9;
    border-right: 1px solid #d9e1e9;
}

.add-border {
    visibility: hidden;
    clear: both;    
}

.el-radio-group .jc-icon-my-help {
    line-height: 18px;
    margin-top: 7px;
    margin-left: -17px;
    margin-right: 10px;
    vertical-align: middle;
}
.el-radio {
    margin: 0 0 0 20px;
}


</style>




// WEBPACK FOOTER //
// src/components/common/PerformanceMonitor/Monitor.vue